import { Platform, Share } from "react-native";
import { STRINGS } from "../constants";
import { getData } from "./storage";

export const shareDetails = async (subdirectory) => {
  try {
    const details = JSON.parse(await getData("trailDetails"));
    const trailDetailsLatLng = JSON.parse(await getData("trailDetailsLatLng"));

    const propertyType =
      details.property_type != null && details.property_type !== ""
        ? STRINGS.property + ": " + details.property_type + "\n"
        : "";
    const fromTo =
      details.st_from != null && details.st_from !== "" && details.st_to != null && details.st_to !== ""
        ? STRINGS.from + " " + details.st_from + " " + STRINGS.to + " " + details.st_to + "\n"
        : "";
    const facilityType =
      details.facility_type != null && details.facility_type !== ""
        ? STRINGS.facilityType + ": " + details.facility_type + "\n"
        : "";
    const category =
      details.category != null && details.category !== "" ? STRINGS.category + ": " + details.category + "\n" : "";
    const routeName =
      details.route_name != null && details.route_name !== ""
        ? STRINGS.routeName + ": " + details.route_name + "\n"
        : "";
    const width =
      details.width != null && details.width !== "" ? STRINGS.trailWidth + ": " + details.width + " feet \n" : "";
    const msg =
      details.segment_name +
      "\n" +
      propertyType +
      fromTo +
      facilityType +
      category +
      routeName +
      width +
      createCommonMessage(details, trailDetailsLatLng, subdirectory, details.OBJECTID);
    createShareDialog(msg, details.segment_name);
  } catch (error) {
    // console.log(error);
  }
};

export const shareDetailsState = async (subdirectory) => {
  const details = JSON.parse(await getData("trailDetails"));
  const trailDetailsLatLng = JSON.parse(await getData("trailDetailsLatLng"));

  const msg =
    details.segment_name + "\n" + createCommonMessage(details, trailDetailsLatLng, subdirectory, details.objectid);
  createShareDialog(msg, details.segment_name);
};

const createCommonMessage = (details, trailDetailsLatLng, subdirectory, id) => {
  const difficulty =
    details.difficulty != null && details.difficulty !== ""
      ? STRINGS.trailDifficulty + ": " + details.difficulty + "\n"
      : "";
  const surface =
    details.surface != null && details.surface !== "" ? STRINGS.surfaceType + ": " + details.surface + "\n" : "";
  const length =
    details.miles != null && details.miles !== ""
      ? STRINGS.trailLength + ": " + Math.ceil(details.miles * 100) / 100 + " miles \n"
      : "";
  const mapLink = "\nDirections: \n" + createMapLink(trailDetailsLatLng.lat, trailDetailsLatLng.lng) + "\n";
  const url = "\n" + STRINGS.domainHost + "/" + subdirectory + "?id=" + id;
  return difficulty + surface + length + mapLink + url;
};

const createMapLink = (lat, lng) => {
  const latLng = `${lat},${lng}`;
  const url = Platform.select({
    ios: `http://maps.apple.com/?q=${latLng}&ll=${latLng}`, //`${scheme}@${latLng}`,
    default: `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`,
  });

  return url;
};

const createShareDialog = async (msg, segment_name) => {
  try {
    await Share.share({ message: msg }, { subject: segment_name });
  } catch (error) {
    // console.log(error);
  }
};
